<script>
  import { onMount } from 'svelte'
  import HeaderLogo from './HeaderLogo.svelte'

  let mounted = false
  let particlesReady = false

  const loadParticles = () => {
    particlesJS.load('particles-js', 'particles.json', function () {
      console.log('callback - particles.js config loaded')
    })
  }

  //Load particle background
  onMount(async () => {
    console.log('mounted')
    mounted = true
    if (particlesReady) {
      loadParticles()
    }
  })

  const particlesLoaded = () => {
    console.log('Particles')
    particlesReady = true
    if (mounted) {
      loadParticles()
    }
  }
</script>

<svelte:head>
  <script src="particles.js" on:load={particlesLoaded} defer>
  </script>
</svelte:head>

<main>
  <div class="particles" id="particles-js" />
  <HeaderLogo />
</main>

<style>
  .particles {
    opacity: 0.5;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 0
  }

</style>
